import { PaletteMode } from "@mui/material";

export const lightModePalette = {
  primary: {
    main: '#4a4a4a', 
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    default: '#F5F5F5',
    paper: '#FFFFFF', 
  },
  action: {
    active: '#000000de',
    hover: '#0000000a',
    selected: '#00000014',
    disabled: '#00000042',
    disabledBackground: '#0000001f',
  },
  text: {
    primary: '#000000de',
    secondary: '#00000099',
    disabled: '#00000061',
  },
};

export const darkModePalette = {
  primary: {
    main: '#E0E0E0',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    default: '#121212',
    paper: '#1E1E1E',
  },
  action: {
    active: '#ffffffde',
    hover: '#ffffff14',
    selected: '#ffffff29',
    disabled: '#ffffff4d',
    disabledBackground: '#ffffff1f',
  },
  text: {
    primary: '#ffffffde',
    secondary: '#ffffffb3',
    disabled: '#ffffff80',
  },
};



const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
        mode,
        ...(mode === 'light' ? lightModePalette : darkModePalette),
    },
});

export default getDesignTokens;
